import { useTranslations } from '@vocab/react';
import { TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import translations from 'src/.vocab';
import lysTranslations from 'src/pages/LinkYourSoftware/.vocab';

import type { FormValues } from '../../../../../ContentState';

export const ContactName = () => {
  const { t } = useTranslations(translations);
  const { t: lys } = useTranslations(lysTranslations);
  const { setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="contactName"
      rules={{
        required: lys('contactNameValidation'),
        validate: (value) => {
          // Check that the string is not just whitespace
          if (!/\S/.test(value)) {
            return t('requiredField');
          }
        },
      }}
      render={({ field, fieldState }) => (
        <TextField
          required
          characterLimit={255}
          id="lys-contact-name-text-field"
          onChange={field.onChange}
          label={lys('contactName')}
          value={field.value}
          onClear={() => setValue('contactName', '')}
          message={fieldState.error?.message}
          tone={fieldState.error && 'critical'}
          data={{ testid: 'lys-contact-name-text-field' }}
        />
      )}
    />
  );
};
